import { Injectable } from '@angular/core'

import { ServiceSchedule } from '@ti/contracts'
import { BaseAlertsServiceScheduleProvider } from '@ti/shared/alerts/providers'

@Injectable()
export class TspAlertsServiceSchedulesProvider extends BaseAlertsServiceScheduleProvider<ServiceSchedule> {
  protected async getServiceSchedules() {
    return []
  }
}
